import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import "./provider.css";
import swal from "sweetalert";
import {
  australiaCampus,
  canadaCampus,
  brazilCampus,
  countries_code,
  franceCampus,
  germanyCampus,
  newZealandCampus,
  pakistanCampus,
  southKoreaCampus,
  chinaCampus,
  uaeCampus,
  ukCampus,
  usaCampus,
  CyprusNorth,
  HungaryCampus,
  FinlandCampus,
  TurkeyCampus,
  NetherlandsCampus,
  SpainCampus,
  IrelandCampus,
  malaysiaCampus,
} from "../../utilis/constants";
import { post_ApiManager, get_ApiManager } from "../ApiManager/ApiManager";
import { getProviderFormLayout } from "./providerFormLayout";
import ProviderFormMultiselect from "./ProviderFormMultiselect";
import {
  applyProviderDescriptionToPayload,
  extractProviderApiErrorMessage,
  resolveProviderDescriptionForSave,
} from "./providerFormHelpers";
import "../../styles/tailwind.css";

const AddProvider = ({
  embedded = false,
  formId,
  onSuccess,
  onCancel,
  onSavingChange,
}) => {
  const titleRef = useRef();
  const history = useNavigate();
  const [input, setInput] = useState("");
  const [tags, setTags] = useState([]);
  const [isKeyReleased, setIsKeyReleased] = useState(false);
  const [nameError, setNameError] = useState("");
  const [campusError, setCampusError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [campus, setCampus] = useState([]);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [allPermissions] = useState(
    getPermissions(),
  );
  const [personList, setPersonList] = useState([
    { name: "", email: "", mobile: "", landline: "", designation: "" },
  ]);

  useEffect(() => {
    document.title = "Add New Provider";
    getCategory();
  }, []);

  const getCategory = async () => {
    let url = "provider-categories";
    let data = "";
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("Provider Categories", res);
        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        const activeCategories = list.filter(
          (item) => item?.active_status !== false && item?.active_status !== 0,
        );
        setCategories(activeCategories);
      },
      (err) => {
        console.log(err);
      },
    );
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...personList];
    list[index][name] = value;
    setPersonList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...personList];
    list.splice(index, 1);
    setPersonList(list);
  };

  const handleAddClick = () => {
    setPersonList([
      ...personList,
      { name: "", email: "", mobile: "", landline: "", designation: "" },
    ]);
  };

  const handleValidation = () => {
    setNameError("");
    setCampusError("");
    setCategoryError("");
    setCountryError("");
    setStartDateError("");
    setEndDateError("");

    if (!name) {
      setNameError("Please enter name");
      window.scrollTo(0, titleRef);
      return false;
    } else if (selectedCampus.length <= 0) {
      setCampusError("Please enter campus");
      window.scrollTo(0, titleRef);
      return false;
    } else if (!category) {
      setCategoryError("Please enter category");
      window.scrollTo(0, titleRef);
      return false;
    } else if (!country) {
      setCountryError("Please enter country");
      window.scrollTo(0, titleRef);
      return false;
    } else if (category == 8) {
      if (!startdate) {
        setStartDateError("Please select start date");
        return false;
      }
      if (!enddate) {
        setEndDateError("Please select end date");
        return false;
      }
    }

    return true;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let array2 = [];
    array2 = selectedCampus.map((object) => object.value);
    var newArray = array2.toString();
    if (handleValidation()) {
      const descriptionValue = resolveProviderDescriptionForSave({
        newDescription: description,
      });
      const data = applyProviderDescriptionToPayload(
        {
          name: name,
          city: newArray,
          country: country,
          address: String(address || "").trim(),
          categoryid: category,
          agreement_startdate: startdate,
          agreement_enddate: enddate,
          person_contact_list: personList,
          designation: selectedOption,
        },
        descriptionValue,
      );
      console.log(data);
      let url = "providers";
      onSavingChange?.(true);
      post_ApiManager(
        data,
        url,
        (res) => {
          onSavingChange?.(false);
          console.log("Added Provider", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            swal("Success!", res.data.message, "success");
            if (embedded && onSuccess) {
              onSuccess();
            } else {
              history("/providers/view-providers");
            }
          }
        },
        (err) => {
          onSavingChange?.(false);
          console.log(err);
          swal(
            " ",
            extractProviderApiErrorMessage(err, "Failed to create provider."),
            "error",
          );
        },
      );
    }
  };

  const onTagChange = (e) => {
    const { value } = e.target;
    setInput(value);
  };

  const onKeyDown = (e) => {
    const { key } = e;
    const trimmedInput = input.trim();

    if (
      key === "," ||
      (key === " " && trimmedInput.length && !tags.includes(trimmedInput))
    ) {
      e.preventDefault();
      setTags((prevState) => [...prevState, trimmedInput]);
      setInput("");
    }

    if (key === "Backspace" && !input.length && tags.length && isKeyReleased) {
      const tagsCopy = [...tags];
      const poppedTag = tagsCopy.pop();
      e.preventDefault();
      setTags(tagsCopy);
      setInput(poppedTag);
    }

    setIsKeyReleased(false);
  };

  const onKeyUp = () => {
    setIsKeyReleased(true);
  };

  const deleteTag = (e, index) => {
    e.preventDefault();
    setTags((prevState) => prevState.filter((tag, i) => i !== index));
  };

  const onCampusSelect = (selectedList) => {
    setSelectedCampus(selectedList);
  };

  const onCampusRemove = (selectedList) => {
    setSelectedCampus(selectedList);
  };

  const setValue = (value) => {
    if (value == "Australia") {
      let options = australiaCampus.map(function (intake) {
        return {
          value: intake.title,
          label: intake.title,
          group: intake.group,
        };
      });
      setCampus(options);
    } else if (value == "Pakistan") {
      let options = pakistanCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value === "Korea South") {
      let options = southKoreaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value === "China") {
      let options = chinaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "UK") {
      let options = ukCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Brazil") {
      let options = brazilCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Canada") {
      let options = canadaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "New Zealand") {
      let options = newZealandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Germany") {
      let options = germanyCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "USA") {
      let options = usaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "France") {
      let options = franceCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "United Arab Emirates") {
      let options = uaeCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Cyprus North") {
      let options = CyprusNorth.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Hungary") {
      let options = HungaryCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Finland") {
      let options = FinlandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Netherlands") {
      let options = NetherlandsCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Turkey") {
      let options = TurkeyCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Spain") {
      let options = SpainCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Ireland") {
      let options = IrelandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Malaysia") {
      let options = malaysiaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    }
    setCountry(value);
  };

  const handleCancel = () => {
    if (embedded && onCancel) {
      onCancel();
      return;
    }
    history("/providers/view-providers");
  };

  const ui = getProviderFormLayout(embedded);

  return (
    <div className={ui.wrap}>
      {allPermissions["providers"] === 1 ? (
        <>
          {!embedded && (
            <button
              type="button"
              onClick={handleCancel}
              className={ui.backBtn}
            >
              <FaChevronLeft size={10} />
              Back to Providers
            </button>
          )}

          <div className={ui.inner}>
            {!embedded && (
              <div className={ui.cardHeader}>
                <h1 className={ui.cardTitle}>ADD New Provider</h1>
              </div>
            )}

            <form
              id={formId}
              ref={titleRef}
              className={ui.form}
              onSubmit={onSubmit}
            >
              <div className={ui.section}>
                <div
                  className={ui.gridClass}
                  {...(ui.gridStyle ? { style: ui.gridStyle } : {})}
                >
                  <div className={ui.field}>
                    <label className={ui.label}>
                      Provider Name <span className={ui.requiredMark}>*</span>
                    </label>
                    <div className={ui.control}>
                      <input
                        type="text"
                        name="name"
                        onChange={(e) => setName(e.target.value)}
                        className={ui.input}
                        placeholder="Please Enter"
                      />
                    </div>
                    {nameError && (
                      <small className={ui.error}>
                        {nameError}
                      </small>
                    )}
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>Category</label>
                    <div className={ui.control}>
                      <select
                        className={ui.select}
                        onChange={(e) => setCategory(e.target.value)}
                        aria-label="Category"
                      >
                        <option selected>Please Select</option>
                        {[]
                          .concat(categories)
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((value, index) => (
                            <option key={index} value={value.id}>
                              {value.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    {categoryError && (
                      <small className={ui.error}>
                        {categoryError}
                      </small>
                    )}
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>
                      Country <span className={ui.requiredMark}>*</span>
                    </label>
                    <div className={ui.control}>
                      <select
                        className={ui.select}
                        onChange={(e) => setValue(e.target.value)}
                        aria-label="Country"
                        name="country"
                      >
                        <option selected>Please Select</option>
                        {countries_code.map((value) => (
                          <option key={value.country} value={value.value}>
                            {value.value}
                          </option>
                        ))}
                      </select>
                    </div>
                    {countryError && (
                      <small className={ui.error}>
                        {countryError}
                      </small>
                    )}
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>
                      Campus <span className={ui.requiredMark}>*</span>
                    </label>
                    <div className={ui.controlMulti}>
                      <ProviderFormMultiselect
                        options={[]
                          .concat(campus)
                          .sort((a, b) => (a.label > b.label ? 1 : -1))}
                        groupBy="group"
                        className={embedded ? "w-full" : ""}
                        placeholder="Please Select"
                        displayValue="label"
                        selectedValues={selectedCampus}
                        onSelect={onCampusSelect}
                        onRemove={onCampusRemove}
                      />
                    </div>
                    {campusError && (
                      <small className={ui.error}>
                        {campusError}
                      </small>
                    )}
                  </div>

                  <div className={ui.fieldFull}>
                    <label className={ui.label}>Address</label>
                    <div className={ui.control}>
                      <textarea
                        className={ui.textarea}
                        name="address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Enter complete provider address"
                        rows={3}
                        aria-label="Address"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={ui.section}>
                <h3 className={ui.sectionTitle}>
                  Contact Person(s)
                </h3>

                {personList.map((x, i) => (
                  <div key={i} className={ui.contactBlock}>
                    <div
                      className={ui.contactGridClass}
                      {...(ui.contactGridStyle ? { style: ui.contactGridStyle } : {})}
                    >
                      <div className={ui.field}>
                        <label className={ui.label}>
                          Person Name
                        </label>
                        <div className={ui.control}>
                          <input
                            type="text"
                            name="name"
                            onChange={(e) => handleInputChange(e, i)}
                            className={ui.input}
                            placeholder="Please Enter"
                          />
                        </div>
                      </div>

                      <div className={ui.field}>
                        <label className={ui.label}>
                          Person Email
                        </label>
                        <div className={ui.control}>
                          <input
                            type="email"
                            name="email"
                            onChange={(e) => handleInputChange(e, i)}
                            className={ui.input}
                            placeholder="Please Enter"
                          />
                        </div>
                      </div>

                      <div className={ui.field}>
                        <label className={ui.label}>
                          Designation
                        </label>
                        <div className={ui.control}>
                          <select
                            className={ui.select}
                            name="designation"
                            onChange={(e) => handleInputChange(e, i)}
                          >
                            <option selected>Please Select</option>
                            <option value="Accounts Manager">
                              Accounts Manager
                            </option>
                            <option value="Admissions Manager">
                              Admissions Manager
                            </option>
                            <option value="Marketing Manager">
                              Marketing Manager
                            </option>
                            <option value="Owner/Director">
                              Owner/Director
                            </option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </div>

                      <div className={ui.field}>
                        <label className={ui.label}>Mobile</label>
                        <div className={ui.control}>
                          <input
                            type="tel"
                            inputMode="tel"
                            autoComplete="tel"
                            name="mobile"
                            onChange={(e) => handleInputChange(e, i)}
                            className={ui.input}
                            placeholder="Please Enter"
                          />
                        </div>
                      </div>

                      <div className={ui.field}>
                        <label className={ui.label}>
                          Landline
                        </label>
                        <div className={ui.control}>
                          <input
                            type="tel"
                            inputMode="tel"
                            autoComplete="tel"
                            name="landline"
                            onChange={(e) => handleInputChange(e, i)}
                            className={ui.input}
                            placeholder="Please Enter"
                          />
                        </div>
                      </div>
                    </div>

                    <div className={ui.contactActions}>
                      {personList.length !== 1 && (
                        <button
                          type="button"
                          className={ui.btnOutlineDanger}
                          onClick={() => handleRemoveClick(i)}
                        >
                          Remove
                        </button>
                      )}
                      {personList.length - 1 === i && (
                        <button
                          type="button"
                          className={ui.btnFill}
                          onClick={() => handleAddClick()}
                        >
                          Add More
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className={ui.section}>
                <h3 className={ui.sectionTitle}>
                  Contract Information
                </h3>

                {category == 8 && (
                  <div
                    className={ui.gridClass}
                    {...(ui.gridStyle ? { style: ui.gridStyle } : {})}
                  >
                    <div className={ui.field}>
                      <label className={ui.label}>
                        Agreement Start Date <span className={ui.requiredMark}>*</span>
                      </label>
                      <div className={ui.control}>
                        <input
                          type="date"
                          onChange={(e) => setStartDate(e.target.value)}
                          className={ui.input}
                        />
                      </div>
                      {startDateError && (
                        <small className={ui.error}>
                          {startDateError}
                        </small>
                      )}
                    </div>

                    <div className={ui.field}>
                      <label className={ui.label}>
                        Agreement End Date <span className={ui.requiredMark}>*</span>
                      </label>
                      <div className={ui.control}>
                        <input
                          type="date"
                          onChange={(e) => setEndDate(e.target.value)}
                          className={ui.input}
                        />
                      </div>
                      {endDateError && (
                        <small className={ui.error}>
                          {endDateError}
                        </small>
                      )}
                    </div>
                  </div>
                )}

                <div
                  className={`${ui.fieldFull}${
                    category == 8 ? ui.notesSpaced : ""
                  }`}
                >
                  <label className={ui.label}>Note (optional)</label>
                  <div className={ui.control}>
                    <textarea
                      className={ui.textarea}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Optional"
                      name="description"
                      rows="3"
                    />
                  </div>
                </div>
              </div>

              {!embedded && (
                <div className={ui.footer}>
                  <button
                    type="submit"
                    className={ui.submitBtn}
                  >
                    Add Provider
                  </button>
                </div>
              )}
            </form>
          </div>
        </>
      ) : (
        <div className={ui.noAccess}>
          You dont have permission to access this pages!
        </div>
      )}
    </div>
  );
};

export default AddProvider;
